import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { ApiError, apiPost } from "../api/client";
import { AuthLayout } from "../components/AuthLayout";

export function ForgotPasswordPage() {
  const [identifier, setIdentifier] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await apiPost("/api/auth/forgot-password", { identifier });
      setSent(true);
    } catch (err) {
      // The endpoint answers the same way for unknown accounts, so the only
      // real error here is being rate limited.
      setError(
        err instanceof ApiError ? err.message : "Couldn't send the reset link"
      );
    } finally {
      setLoading(false);
    }
  }

  if (sent) {
    return (
      <AuthLayout
        title="Check your email"
        intro="If that account exists, a reset link is on its way. It works once and expires in 30 minutes."
        footer={<Link to="/login">Back to sign in</Link>}
      >
        <></>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Reset your password"
      intro="Enter your username or the email on your account and we'll send you a link to set a new password."
      footer={
        <span className="auth-footer-alt">
          Remembered it? <Link to="/login">Sign in</Link>
        </span>
      }
    >
      <form onSubmit={handleSubmit} className="auth-form">
        {error && (
          <div className="error" role="alert">
            {error}
          </div>
        )}
        <label>
          <span className="field-label">Username or email</span>
          <input
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>
        <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
          {loading ? "Sending…" : "Send reset link"}
        </button>
      </form>
    </AuthLayout>
  );
}
